import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAuthOtp from './reducers/auth-otp.reducer';
import { EffectsModule } from '@ngrx/effects';
import { AuthOtpEffects } from './effects/auth-otp.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ AuthOtpEffects ]),
    StoreModule.forFeature('authOtp', fromAuthOtp.reducer),
    StoreModule.forFeature('checkAuthOtp', fromAuthOtp.checkAuthOTPreducer),
    StoreModule.forFeature('enableAuthOtp', fromAuthOtp.enableAuthOTPreducer),
  ]
})
export class AuthOTPModule { }
